import { useQuery } from '@apollo/client/react';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { WidgetsApp } from '@/components';

import { PlayersWidget } from '../../components/Widgets/PlayersWidget';

import { GetWidgetDocument } from './_internal/Widget.query.generated';

const WidgetPlayers = () => {
  const router = useRouter();

  const getWidget = useQuery(GetWidgetDocument, {
    variables: {
      widgetId: Number(router.query.widgetId),
      cacheTTL: router.query.noCache ? 0 : undefined,
    },
    skip: !router.query.widgetId,
    context: {
      role: 'anonymous',
    },
  });

  const widget = getWidget.data?.widgets_widget_by_pk;

  const members =
    getWidget.data?.widgets_widget_by_pk?.widget_teams?.[0]?.team_detail?.[0]
      ?.team_in_season?.members;

  return (
    <WidgetsApp widget={widget}>
      <PlayersWidget members={members} />
    </WidgetsApp>
  );
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'fr', [
      'snc-components',
      'snc-core',
      'common',
    ])),
  },
});

export default WidgetPlayers;
